import * as THREE from "three";
import { makeLine } from "./convert";
import { GridShader } from "./materials/shaders/gridShader";

const AXIS_LENGTH = 9000;
const blueMat = new THREE.LineBasicMaterial({ color: 0x0000ff, name: "threeGrid2DCreate blueMat" });
const planeGeom = new THREE.PlaneGeometry(AXIS_LENGTH * 2, AXIS_LENGTH * 2, 1, 1);
planeGeom.userData.isCached = true;

const gridMaterial = new THREE.ShaderMaterial({
  defines: { OPAQUE: 1 },
  fragmentShader: GridShader.fragmentShader,
  vertexShader: GridShader.vertexShader,
  uniforms: THREE.UniformsUtils.clone(GridShader.uniforms),
  blending: THREE.NoBlending,
  depthTest: true,
  depthWrite: true,
  name: "threeGrid2DCreate GridMaterial",
});

export function threeGrid2DCreate(parent: THREE.Object3D, z: number): THREE.ShaderMaterial {
  const positiveZLine = makeLine(0, 0, z, 0, 0, z + AXIS_LENGTH, blueMat);
  parent.add(positiveZLine);
  positiveZLine.updateMatrix();
  positiveZLine.matrixAutoUpdate = false;

  const gridMesh = new THREE.Mesh(planeGeom, gridMaterial);
  gridMesh.position.z = z;
  parent.add(gridMesh);
  gridMesh.updateMatrix();
  gridMesh.matrixAutoUpdate = false;

  return gridMaterial;
}
